import "leaflet/dist/leaflet.css";

let leafletPromise: Promise<any> | null = null;

export function loadLeaflet(): Promise<any> {
    leafletPromise ??= Promise.resolve()
        .then(() => require("leaflet"))
        .catch(error => {
            leafletPromise = null;
            throw error;
        });
    return leafletPromise;
}
